const version_check_modal = {
  title: '¡Nueva actualización disponible!',
  description:
    'Hemos realizado mejoras y añadido nuevas funciones para mejorar tu experiencia. ¡Actualiza App para disfrutar de la aplicación completa!',
  cta: 'Actualizar ahora',
}

export default version_check_modal
